import { useContext } from 'react';
import { Context } from '../context';
import { ArticleSearchResultItem } from '../types';

export enum OptInModalStatus {
  Confirm = 'confirm',
  Failed = 'failed',
  Closed = 'closed',
}

export const useOptInUtils = (article: ArticleSearchResultItem, locale: string, togglePopulationStatus: (featureId: string) => void, setOptInModalStatus: (optInModalStatus: OptInModalStatus) => void) => {
  const context = useContext(Context);
  const { answersApi } = context;

  const optIn = async () => {
    if (!article.featureEnrollment?.featureId) { return; }
    togglePopulationStatus(article.featureEnrollment.featureId);
    setOptInModalStatus(OptInModalStatus.Closed);
    try {
      await answersApi.kb.joinPopulation({ populationId: article.featureEnrollment.featureId });
    } catch (e) {
      setOptInModalStatus(OptInModalStatus.Failed);
      togglePopulationStatus(article.featureEnrollment.featureId);
      return;
    }
    try {
      await answersApi.kb.optInFeature({ id: article.id, locale });
    } catch (e) {
      setOptInModalStatus(OptInModalStatus.Failed);
      togglePopulationStatus(article.featureEnrollment.featureId);
      await answersApi.kb.leavePopulation({ populationId: article.featureEnrollment.featureId });
      return;
    }
  };

  const optOut = async () => {
    if (!article.featureEnrollment?.featureId) { return; }
    togglePopulationStatus(article.featureEnrollment.featureId);
    await answersApi.kb.leavePopulation({ populationId: article.featureEnrollment.featureId });
    await answersApi.kb.optOutFeature({ id: article.id, locale });
  };

  return { optIn, optOut };
};
